import React, { useEffect } from 'react';

const Callback: React.FC = () => {
  useEffect(() => {
    console.log("Processing Keycloak callback...");
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto"></div>
        <p className="mt-6 text-lg text-gray-700 font-medium">Authenticating...</p>
        <p className="mt-2 text-sm text-gray-500">Please wait while we log you in</p>
      </div>
    </div>
  );
};

export default Callback;